module.exports = __webpack_public_path__ + "media/images/countrysquared/cz-fa1ea62eacc58f9d283f9aa143c7344f.svg";